module.exports = __webpack_public_path__ + "static/media/projectPic11.1b1007c6.png";